import {
  BadgeIcon,
  SelectableEntity,
  StandardEntity,
} from '@infodata-group/inf-commons';
import dayjs from 'dayjs';
import { Absence } from './absence';
import { Schedule } from './schedule';
import { HolidayTask } from './holiday-task';

export class Employee extends SelectableEntity {
  get schedules(): Schedule[] {
    return this._schedules;
  }

  set schedules(value: Schedule[]) {
    this._schedules = value;
    this._weekCount = this.schedules
      ? this._schedules.reduce((total, sch) => (total += sch.getTotal()), 0)
      : 0;
  }

  get weekCount(): number {
    return this._weekCount;
  }
  get photo(): string {
    return this._photo;
  }

  set photo(value: string) {
    this._photo = value;
    if (value) {
      this.badge = `api/auth/file/${value}`;
    } else {
      this.badge = new BadgeIcon(this.label);
    }
  }
  public service: StandardEntity;
  public holidays: Date[];
  public job: string;
  public company: StandardEntity;
  private _schedules: Schedule[];
  private _photo: string;
  public badge: BadgeIcon | string;
  public informant: boolean;
  private _weekCount = 0;

  public get serviceLabel(): string {
    return this.service.label;
  }

  constructor(
    id: string,
    nom: string,
    prenom: string,
    service: StandardEntity,
    holidays: Date[],
  ) {
    super(id, nom + ' ' + prenom);
    this.service = service;
    this.holidays = holidays ?? [];
    this.badge = new BadgeIcon(this.label);
  }

  public toString(): string {
    return this.label;
  }

  generateHolidays(): Absence[] {
    return this.holidays.map((h) => {
      const end = dayjs(h);
      end.endOf('day');
      return new HolidayTask(h);
    });
  }
}
